import { Box, Stack, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import type { Stage, VenueList } from 'api-client';
import { VenueStageFields } from '@/venues/components/VenueStageFields';

export interface HoldQuickCreateDraft {
  title: string;
  venueId: string;
  stageId: string;
  notes: string;
}

interface HoldQuickCreateFieldsProps {
  value: HoldQuickCreateDraft;
  onChange: (value: HoldQuickCreateDraft) => void;
  startDate: Date | null;
  endDate: Date | null;
  onStartDate: (date: Date | null) => void;
  onEndDate: (date: Date | null) => void;
  venues: VenueList[];
  stages: Stage[];
  disabled: boolean;
}

export function HoldQuickCreateFields({
  value, onChange, startDate, endDate, onStartDate, onEndDate, venues, stages, disabled,
}: HoldQuickCreateFieldsProps) {
  return (
    <Stack spacing={2.5}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <DatePicker
          label="Start Date" value={startDate} disabled={disabled}
          onChange={(date) => {
            onStartDate(date);
            if (date && endDate && date > endDate) onEndDate(date);
          }}
          slotProps={{ textField: { size: 'small', fullWidth: true, required: true } }}
        />
        <DatePicker
          label="End Date" value={endDate} disabled={disabled} minDate={startDate || undefined}
          onChange={(date) => {
            onEndDate(date);
            if (date && startDate && date < startDate) onStartDate(date);
          }}
          slotProps={{ textField: { size: 'small', fullWidth: true, required: true } }}
        />
      </Stack>
      <TextField
        label="Show Title" fullWidth required value={value.title} disabled={disabled}
        onChange={(event) => onChange({ ...value, title: event.target.value })}
        placeholder="Enter show or artist name"
      />
      <VenueStageFields
        venues={venues} stages={stages} value={{ venue: value.venueId, stage: value.stageId }} disabled={disabled}
        onChange={(selection) => onChange({ ...value, venueId: selection.venue, stageId: selection.stage })}
      />
      <TextField
        label="Notes (optional)" fullWidth multiline minRows={2} value={value.notes} disabled={disabled}
        onChange={(event) => onChange({ ...value, notes: event.target.value })}
      />
      <Box>
        <Typography variant="body2" color="text.secondary">
          Positions are assigned when holds are saved. On confirmed dates, new holds are kept on standby.
        </Typography>
      </Box>
    </Stack>
  );
}
